import { render, staticRenderFns } from "./ProgramSchoolView.vue?vue&type=template&id=01d3c59b&"
import script from "./ProgramSchoolView.vue?vue&type=script&lang=js&"
export * from "./ProgramSchoolView.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSchoolView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports